module.exports = __webpack_public_path__ + "static/media/schliffe_loesung.d90c91f9.jpg";